import styles from './index.module.css'
import classnames from 'classnames'

const Input = ({ disabled, errorMsg, errorClassName, onChange, ...props }) => {
    return (
        <input
            disabled={disabled}
            type="text"
            className={classnames(styles.input, errorClassName)}
            onChange={(e) => onChange(e.currentTarget.value, e)}
            {...props}
        />
    )
}

const Label = ({ label, required, disabled, errorClassName, ...props }) => {
    return (
        <label className={styles.label}>
            {label}
            {required && <span className={styles.required}>*</span>}
            <Input disabled={disabled} errorClassName={errorClassName} {...props} />
        </label>
    )
}

const Search = ({ disabled }) => {
    return (
        <button type="submit" className={styles.search_button} disabled={disabled}>
            <span className="Appkit4-icon icon-search-outline"></span>
        </button>
    )
}

export const View = ({ width, label, search, disabled, hasError, errorMsg, className, ...props }) => {
    const searchClassName = search ? styles.search : ''
    const errorClassName = hasError || errorMsg ? styles.error : ''

    return (
        <div style={{ width }} className={classnames(styles.default, className)}>
            <div className={searchClassName}>
                {label ? (
                    <Label label={label} disabled={disabled} errorClassName={errorClassName} {...props} />
                ) : (
                    <Input disabled={disabled} errorClassName={errorClassName} {...props} />
                )}
                {search && <Search disabled={disabled} />}
            </div>
            {errorMsg && <span className={styles.error_msg}>{errorMsg}</span>}
        </div>
    )
}
